export const PAYMENT_SURVEY_ID = '7539394f';
export const PAYMENT_SURVEY_URL = `https://promotion.zep.us/sales-form#${PAYMENT_SURVEY_ID}`;
export const PAYMENT_SURVEY_STORAGE_PREFIX = 'quiz-payment-survey-hidden:';
export const PAYMENT_COMPLETE_TOAST_BOTTOM_OFFSET = 36;
